import { Theme, css } from '@emotion/react';

export const tabStylesContained = ({ colors }: Theme) => css`
  border-bottom: 1px solid ${colors['borderLight']};
`;
